import { useMemo } from 'react'
import { FilterProps } from 'react-table'
import { SelectChangeEvent } from '@mui/material'
import { InputSearchDropdown } from '../../..'
import { EnhancedHeader } from '../../../../types'

interface Props<D extends object> extends FilterProps<D> {
  column: EnhancedHeader<D>
  columns: EnhancedHeader<D>[]
}

export default function MultiSelectFilter<D extends object>({
  column,
  column: { filterValue, preFilteredRows, setFilter },
}: Props<D>) {
  const options: string[] = useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach((row) => {
      options.add(row.values[column.id])
    })
    return [...options.values()] as string[]
  }, [column.id, preFilteredRows])

  return (
    <InputSearchDropdown
      label="Filter Value"
      size="small"
      fullWidth
      value={filterValue || []}
      onChange={(evt: SelectChangeEvent) => setFilter(evt.target.value)}
      getOptionLabel={(option) => option?.toString()}
      options={options}
      disableCloseOnSelect
      multiple
    />
  )
}
